import {
  AppstoreAddOutlined,
  AppstoreOutlined,
  BorderOuterOutlined,
  ClockCircleOutlined,
  ContactsOutlined,
  DeploymentUnitOutlined,
  DownOutlined,
  FileFilled,
  FileMarkdownFilled,
  FileSyncOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  PlusCircleFilled,
  PlusCircleOutlined,
  PlusOutlined,
  ReconciliationOutlined,
  SettingOutlined,
  ShopOutlined,
  SolutionOutlined,
  TeamOutlined,
  UnorderedListOutlined,
  UserOutlined,
  ZhihuOutlined,
  ProductOutlined,
} from "@ant-design/icons";
import { Avatar, Dropdown, Layout, Menu } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useMediaQuery } from "react-responsive";
import { Outlet, useNavigate } from "react-router-dom";
import { logout } from "../../redux/slices/authSlice";
import UpdateCompensationModal from "../UpdateCompensationModal"; // Import the new modal component
import { getUserRole } from "../../utils/auth";
import { useSelector } from "react-redux";

const { Header, Content } = Layout;

const AppLayout = () => {
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const [isCompensationModalVisible, setIsCompensationModalVisible] =
    useState(false); // State for modal visibility
  const [userRole, setUserRole] = useState(null);
  const [showRcInsurancePayment, setShowRcInsurancePayment] = useState(false);

  // Get product settings from Redux
  const productSettings = useSelector(
    (state) => state.productSetting?.productSetting
  );

  useEffect(() => {
    if (isMobile) {
      setCollapsed(true);
    }
    // Get user role for menu visibility
    const role = getUserRole();
    setUserRole(role);
  }, [isMobile]);

  // Check if RC Insurance Payment should be shown based on tracking number settings
  useEffect(() => {
    if (productSettings && productSettings.length > 0) {
      const userData = JSON.parse(localStorage.getItem("userData"));
      let shouldShow = false;

      if (userData?.role === "admin") {
        // For admin, show if any store has tracking number enabled
        shouldShow = productSettings.some(
          (setting) => setting.engineNumber === "Yes"
        );
      } else if (userData?.storeId) {
        // For non-admin users, check their specific store
        const userStoreSetting = productSettings.find(
          (setting) => setting.storeId === userData.storeId
        );
        shouldShow = userStoreSetting?.engineNumber === "Yes";
      } else {
        // If no storeId, don't show
        shouldShow = false;
      }

      setShowRcInsurancePayment(shouldShow);
    } else {
      // If no product settings loaded yet, don't show
      setShowRcInsurancePayment(false);
    }
  }, [productSettings]);

  const handleLogout = () => {
    dispatch(logout());
    navigate("/login");
  };

  const user = JSON.parse(localStorage.getItem("userData"));

  const toggleCollapse = () => {
    setCollapsed(!collapsed);
  };

  const handleMenuClick = (item) => {
    if (item.key === "update-compensation") {
      setIsCompensationModalVisible(true); // Show modal
    } else {
      navigate(item.key);
    }
  };

  const userMenu = (
    <Menu>
      <Menu.Item key="username" disabled>
        <b>{user.email}</b>
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item key="profile" onClick={() => navigate("/profile")}>
        My Profile
      </Menu.Item>
      <Menu.Item key="changePassword" onClick={() => navigate("/profile")}>
        Change Password
      </Menu.Item>
      <Menu.Item key="logout" onClick={() => handleLogout()}>
        Logout
      </Menu.Item>
    </Menu>
  );

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Header
        style={{
          background: "linear-gradient(135deg, #3f87a0, #3f87a6 )", // Gradient background
          padding: "0 10px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          height: "20px", // Increase height for a better layout
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)", // Subtle shadow for depth
        }}
      >
        <div
          onClick={toggleCollapse}
          style={{
            cursor: "pointer",
            marginRight: "16px",
            color: "#fff", // Icon color to contrast with the gradient
            fontSize: "12px", // Increased icon size for better visibility
          }}
        >
          {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
        </div>
        <div
          style={{
            fontWeight: "",
            fontSize: isMobile ? "10px" : "11px", // Adjust font size for responsiveness
            color: "#fff", // Logo color
            letterSpacing: "1px", // Slight spacing for a modern look
          }}
        >
          Welcome to the Admin Panel
        </div>
        <Dropdown overlay={userMenu} placement="bottomRight">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              cursor: "pointer",
              color: "#fff",
            }}
          >
            <Avatar
              style={{
                backgroundColor: "#87d068",
                marginRight: "10px",
                border: "0px solid #fff",
                fontSize: isMobile ? "10px" : "12px",
                width: isMobile ? "16px" : "17px", // smaller width
                height: isMobile ? "16px" : "17px", // smaller height
                lineHeight: isMobile ? "28px" : "30px", // align icon
              }}
              icon={<UserOutlined />}
            />
            <span
              style={{
                fontWeight: "bold",
                marginRight: "4px",
                fontSize: isMobile ? "10px" : "12px", // Adjust name font size for mobile
                color: "#fff", // Name text color
              }}
            >
              {user.name}
            </span>
            <DownOutlined style={{ color: "#fff" }} />
          </div>
        </Dropdown>
      </Header>
      <Layout>
        <Menu
          theme="light"
          mode="horizontal"
          defaultSelectedKeys={["1"]}
          onClick={handleMenuClick}
          style={{ marginBottom: "10px" }}
        >
          <Menu.Item
            key="/"
            icon={<AppstoreOutlined />}
            style={{ fontWeight: "bold", fontSize: "14px", color: "#333" }}
          >
            Dashboard
          </Menu.Item>
          {userRole?.role === "admin" && (
            <Menu.SubMenu
              key="settings"
              icon={<SettingOutlined />}
              title="Settings"
              style={{ fontWeight: "bold", fontSize: "14px" }}
            >
              <Menu.Item key="/profile" icon={<DeploymentUnitOutlined />}>
                My Profile
              </Menu.Item>
              <Menu.Item key="/users" icon={<DeploymentUnitOutlined />}>
                Users Creations
              </Menu.Item>
              <Menu.Item key="/branches" icon={<DeploymentUnitOutlined />}>
                Branche Management
              </Menu.Item>
              <Menu.Item key="/stores" icon={<ShopOutlined />}>
                Stores & Products
              </Menu.Item>
              <Menu.Item key="/product/setting" icon={<ProductOutlined />}>
                Product Setting
              </Menu.Item>
              <Menu.Item key="/bank-accounts" icon={<DeploymentUnitOutlined />}>
                Bank Accounts
              </Menu.Item>
              <Menu.Item key="/tracking" icon={<ClockCircleOutlined />}>
                Tracking
              </Menu.Item>
            </Menu.SubMenu>
          )}
          {userRole?.role !== "admin" && (
            <Menu.Item
              key="/profile"
              icon={<DeploymentUnitOutlined />}
              style={{ fontWeight: "bold", fontSize: "14px" }}
            >
              My Profile
            </Menu.Item>
          )}
          <Menu.SubMenu
            key="products"
            icon={<UnorderedListOutlined />}
            title="Products"
            style={{ fontWeight: "bold", fontSize: "14px" }}
          >
            <Menu.Item key="products/brands" icon={<DeploymentUnitOutlined />}>
              Brands
            </Menu.Item>
            <Menu.Item key="products/taxes" icon={<DeploymentUnitOutlined />}>
              Taxes
            </Menu.Item>
            <Menu.Item
              key="products/product-model"
              icon={<DeploymentUnitOutlined />}
            >
              Product Models
            </Menu.Item>
            <Menu.Item key="products/categories" icon={<AppstoreOutlined />}>
              Categories
            </Menu.Item>
            <Menu.Item key="/ProductForm" icon={<DeploymentUnitOutlined />}>
              Products Entry
            </Menu.Item>
            <Menu.Item key="/products/damaged" icon={<BorderOuterOutlined />}>
              Damaged Products
            </Menu.Item>
            <Menu.Item key="/products" icon={<DeploymentUnitOutlined />}>
              Product List
            </Menu.Item>
          </Menu.SubMenu>
          <Menu.SubMenu
            key="sales"
            icon={<PlusOutlined />}
            title="Sales/Billing"
            style={{ fontWeight: "bold", fontSize: "14px" }}
          >
            <Menu.Item key="saleForm" icon={<PlusCircleOutlined />}>
              Create New Bill
            </Menu.Item>

            {showRcInsurancePayment && (
              <Menu.Item
                key="/rc-insurance-payment"
                icon={<FileSyncOutlined />}
              >
                RC Insurance Payment
              </Menu.Item>
            )}

            <Menu.Item key="sales" icon={<DeploymentUnitOutlined />}>
              View Sale List
            </Menu.Item>
            {/* <Menu.Item key="/sales/pos" icon={<ShopOutlined />}>
              POS
            </Menu.Item> */}
            <Menu.Item key="/sales/salesreturn" icon={<AppstoreOutlined />}>
              View Sale Return
            </Menu.Item>
            <Menu.Item key="sales/replaced" icon={<ReconciliationOutlined />}>
              View Sales Replaced
            </Menu.Item>
            <Menu.Item
              key="update-compensation"
              icon={<ReconciliationOutlined />}
            >
              Update Compensation
            </Menu.Item>
          </Menu.SubMenu>
          <Menu.SubMenu
            key="purchase"
            icon={<UnorderedListOutlined />}
            title="Purchase"
            style={{ fontWeight: "bold", fontSize: "14px" }}
          >
            <Menu.Item key="purchaseForm" icon={<PlusCircleFilled />}>
              Create Purchase Invoice
            </Menu.Item>
            <Menu.Item key="purchase" icon={<DeploymentUnitOutlined />}>
              View Purchase List
            </Menu.Item>
            <Menu.Item
              key="/purchase/purchasereturn"
              icon={<AppstoreOutlined />}
            >
              View Purchase Return
            </Menu.Item>
          </Menu.SubMenu>
          <Menu.SubMenu
            key="stocks"
            icon={<UnorderedListOutlined />}
            title="Stock Management"
            style={{ fontWeight: "bold", fontSize: "14px" }}
          >
            <Menu.Item key="store/stock-add" icon={<AppstoreAddOutlined />}>
              Add New Stock
            </Menu.Item>
            <Menu.Item
              key="stock-movements/add"
              icon={<DeploymentUnitOutlined />}
            >
              Stock Transfer Branch to Branch
            </Menu.Item>
            <Menu.Item key="stock-movements" icon={<DeploymentUnitOutlined />}>
              Stock Transfer/Movement Report
            </Menu.Item>
            {userRole?.role === "admin" && (
              <Menu.Item key="/stock-audit" icon={<FileMarkdownFilled />}>
                Stock Audit
              </Menu.Item>
            )}
          </Menu.SubMenu>
          <Menu.SubMenu
            key="employee"
            icon={<TeamOutlined />}
            title="Employee"
            style={{ fontWeight: "bold", fontSize: "14px" }}
          >
            <Menu.Item key="/employee" icon={<UserOutlined />}>
              Create Employees
            </Menu.Item>
            {userRole?.role === "admin" && (
              <Menu.Item key="/employee-salary" icon={<UserOutlined />}>
                Employee Salary
              </Menu.Item>
            )}
            <Menu.Item
              key="/employee-attendance"
              icon={<ClockCircleOutlined />}
            >
              Employee Attendance
            </Menu.Item>
          </Menu.SubMenu>
          <Menu.SubMenu
            key="reports"
            icon={<UnorderedListOutlined />}
            title="Reports"
            style={{ fontWeight: "bold", fontSize: "14px" }}
          >
            <Menu.Item key="/sales/report" icon={<FileSyncOutlined />}>
              Sales Report
            </Menu.Item>
            <Menu.Item
              key="/rc-payment-insurance/report"
              icon={<FileSyncOutlined />}
            >
              Rc Insurance Payment Report
            </Menu.Item>
            <Menu.Item key="/sales/summary" icon={<FileSyncOutlined />}>
              Sales Summary
            </Menu.Item>
            <Menu.Item key="/purchase/report" icon={<FileSyncOutlined />}>
              Purchase Report
            </Menu.Item>
            {/* {userRole?.role === "admin" && (
              <Menu.Item
                key="/sales/profit/invoice"
                icon={<FileSyncOutlined />}
              >
                Profit Report
              </Menu.Item>
            )} */}
            {userRole?.role === "admin" && (
              <Menu.Item key="/sales/profit-report" icon={<FileSyncOutlined />}>
                New Profit Report
              </Menu.Item>
            )}
            <Menu.Item key="store/stock-report" icon={<FileFilled />}>
              Stock Report
            </Menu.Item>
            {/* {userRole?.role === "admin" && (
              <Menu.Item key="employee/report" icon={<FileFilled />}>
                Employee Commission Entry
              </Menu.Item>
            )} */}
            {userRole?.role === "admin" && (
              <Menu.Item key="commission/report" icon={<FileFilled />}>
                Commission Reports
              </Menu.Item>
            )}

            {userRole?.role === "admin" && (
              <Menu.Item
                key="/sales/without-purchase-price"
                icon={<FileFilled />}
              >
                Sales without Purchase Price
              </Menu.Item>
            )}
          </Menu.SubMenu>
          <Menu.SubMenu
            key="accounts"
            icon={<UnorderedListOutlined />}
            title="Accounts"
            style={{ fontWeight: "bold", fontSize: "14px" }}
          >
            <Menu.Item key="/customers" icon={<UserOutlined />}>
              Create Customers
            </Menu.Item>
            {userRole?.role === "admin" && (
              <Menu.Item key="/supplier" icon={<UserOutlined />}>
                Create Suppliers
              </Menu.Item>
            )}
            {userRole?.role === "admin" && (
              <Menu.Item key="/expense/heads" icon={<UserOutlined />}>
                Expense Head
              </Menu.Item>
            )}
            <Menu.Item key="/expenses" icon={<UserOutlined />}>
              Expenses
            </Menu.Item>
            {userRole?.role === "admin" && (
              <Menu.Item
                key="/accounts/payments/supplier"
                icon={<FileSyncOutlined />}
              >
                Supplier Payments
              </Menu.Item>
            )}

          {userRole?.role === "admin" && (
               <Menu.Item
               key="/accounts/payments/payment-collection"
               icon={<FileSyncOutlined />}
             >
               Customer Payments
             </Menu.Item>
            )} 
           {userRole?.role === "admin" && (
              <Menu.Item key="employee/report" icon={<FileFilled />}>
                Employee Commission Entry
              </Menu.Item>
            )}
            
            {userRole?.role === "admin" && (
              <Menu.Item
                key="/accounts/payments/cancelled"
                icon={<FileSyncOutlined />}
              >
                Customer Payments Returns
              </Menu.Item>
            )}
            {userRole?.role === "admin" && (
              <Menu.Item key="/accounts/gst-report" icon={<FileSyncOutlined />}>
                GST Report
              </Menu.Item>
            )}
            {userRole?.role === "admin" && (
              <Menu.Item
                key="/accounts/balance-sheet"
                icon={<FileSyncOutlined />}
              >
                Balancesheet
              </Menu.Item>
            )}
          </Menu.SubMenu>
        </Menu>
        <Content style={{ padding: "0 20px" }}>
          <Outlet />
          <UpdateCompensationModal
            visible={isCompensationModalVisible}
            onCancel={() => setIsCompensationModalVisible(false)}
          />
        </Content>
      </Layout>
    </Layout>
  );
};

export default AppLayout;
